import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async logIn(variables) {
		const res = await gql({
			query: query.logIn,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "token"
		})
	},

	async me(variables) {
		const res = await gql({
			query: query.me,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "me"
		})
	},

	async readRoles(variables) {
		const res = await gql({
			query: query.readRoles,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "permissionGroups"
		})
	},

	async newPassword(variables) {
		const res = await gql({
			query: mutation.newPassword,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "resetPassword"
		})
	},

	async forgotPassword(variables) {
		const res = await gql({
			query: mutation.forgotPassword,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "forgotPassword"
		})
	},

	async changePassword(variables) {
		const res = await gql({
			query: mutation.changePassword,
			variables
		})
		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "changePassword"
		})
	},

	async passwordValidators(variables) {
		const res = await gql({
			query: query.passwordValidators,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithoutStatus",
			res,
			resKey: "passwordValidators"
		})
	}
}
